import React, { Suspense } from 'react';
import Loading from '../Loading/Loading';

const LazyWrapper = ({ children }) => {
  return (
    <Suspense fallback={<Loading message="A carregar página" />}>
      {children}
    </Suspense>
  );
};

export default LazyWrapper;